import * as React from 'react';

import SuperCritical from 'lib/supercritical';

import { BerthAssignmentDetailsInPortOpsTab as InPortOpsTab } from './inportops';

import { InPortOpsView } from 'portcall/inportops/view';

export const BerthAssignmentDetailsInPortOpsTabView = SuperCritical(({ model: m } : { model : InPortOpsTab }) =>
    <div className="berthassignmentdetailsinportopstab">
        <InPortOpsView model={m.InPortOps} />
    </div>
);



// WEBPACK FOOTER //
// ./apps/portcall/berthassignmentdetails/inportopsview.tsx